import React, {useState} from "react";
import "./QvtPage.css";
import {trackTestStarted, trackTestFinished} from "../analytics";

const QUESTIONS = [
    "Lors des procédures de recrutement, mon administration s'est présentée telle que je la pratique au quotidien en tant qu'employé.",
    "Mon poste correspond à la description qui m'en avait été faite.",
    "Les conditions de travail au sein de mon administration correspondent à son image publique.",
    "La culture de mon administration correspond dans les faits à la présentation qu'en font le site officiel ou ses publications.",
    "L'organisation tient les promesses qu'elle fait à ses agents, par exemple concernant les perspectives de promotion.",
    "Mon administration dit la vérité, par exemple lors des conférences de presse.",
    "Mon administration exécute réellement les missions qu'elle affiche.",
    "Les ressources budgétaires sont évaluées et réparties de manière équitable et transparente.",
    "Mon administration fait le maximum pour la qualité et l'efficacité de ses missions.",
    "Les usagers et les partenaires sont toujours bien accueillis même s'ils ont des réclamations.",
    "La rotation du personnel est réduite.",
    "La sécurité et la santé des agents est une priorité.",
    "Aucun service n'a été ou ne doit être restructuré ou supprimé dans le but de réduire les coûts.",
    "Aucun contrat de travail n'est dénoncé sans raisons graves et extrêmes.",
    "Le personnel temporaire permet de répondre à un besoin avéré ponctuel et n'a jamais vocation à remplacer les agents titulaires.",
    "Les agents séniors sont appréciés et maintenus à leur poste jusqu'à leur départ en retraite.",
    "Les cas de harcèlements sont exceptionnels.",
    "Les primes et gratifications augmentent régulièrement et sont attribuées équitablement.",
    "La réglementation est respectée même en l'absence de vérification externe.",
    "L'agent qui signale une infraction à la législation n'est pas considéré comme un traître, mais comme une personne responsable.",
    "La communication entre agents et services fonctionne bien.",
    "Tous les services travaillent dans le même sens.",
    "Les objectifs sont clairs et les agents les connaissent.",
    "Le management est stable, les restructurations sont exceptionnelles.",
    "Le nombre de réunions, limité au nécessaire, est pertinent.",
    "Les contraintes administratives, par exemple les procédures à respecter, sont raisonnables.",
    "La plupart des décisions ne sont pas des effets d'annonce et concernent le long terme.",
    "Mes supérieurs hiérarchiques changent rarement.",
    "Je suis informé des événements importants concernant mon secteur ou mon organisation.",
    "Je suis jugé sur mes performances réelles, pas uniquement sur mon autopromotion.",
    "Mon supérieur est compétent et responsable.",
    "Mon directeur m'adresse régulièrement des retours constructifs sur mon travail.",
    "En cas d'erreurs, mon supérieur me couvre.",
    "Les meilleures propositions sont retenues, peu importe de qui elles viennent.",
    "L'encadrement ne prend pas de décisions importantes sans consulter au préalable les personnes concernées.",
    "Je me sens considéré en tant que personne, pas uniquement comme main-d'œuvre.",
    "On soutient le développement de mes compétences personnelles.",
    "Lorsque je suis en arrêt maladie, je ne ressens pas la pression de devoir reprendre rapidement le travail.",
    "Les échanges verbaux se font sur un mode courtois et amical.",
    "Je crois que mon organisation me fait confiance sur le plan personnel et sur le plan professionnel.",
];

const RESULTS = [
    {min: 40, max: 80, emoji: "😡", label: "Vous travaillez dans une maison de fous !", color: "#7B1111", bg: "#fdecea", border: "#D4845A", barColor: "#b71c1c", msg: "Sincères condoléances ! La maison de fous dans laquelle vous travaillez mérite réellement son nom. Il manque tout ce qui fait un lieu de travail sain et raisonnable, de l'honnêteté à une gouvernance efficace. Ce type d'organisation est toxique, si d'autres collègues obtiennent le même score, fuyez ! Si vous le pouvez…"},
    {min: 81, max: 119, emoji: "😕", label: "Une maison de fous… relative.", color: "#7a3e00", bg: "#F4D2BC", border: "#D4845A", barColor: "#D4845A", msg: "Vous êtes dans une maison de fous « relative » : elle marche suffisamment sur la tête pour rendre fous ses collaborateurs, mais se montre suffisamment normale pour assurer ses missions. Repérez ce qui fait défaut à votre organisation. Jusqu'à quel point ces manquements sont-ils en opposition avec vos convictions personnelles ? Que vous deviez ou non quitter d'urgence le navire dépend de votre réponse."},
    {min: 120, max: 135, emoji: "😐", label: "Quelques signes de démence passagers.", color: "#7a5c00", bg: "#FFE9AE", border: "#FFC000", barColor: "#FFC000", msg: "Sans être complètement cintrée, votre organisation présente de légers signes de démence. Il peut s'agir de coups de folie passagers, réservés à des domaines précis, de névroses bénignes, de marottes, de bizarreries plutôt divertissantes. Tant que vous avez le sentiment de pouvoir vivre en accord avec vos convictions personnelles, votre motivation peut ne pas être affectée…"},
    {min: 136, max: 160, emoji: "🙂", label: "Une organisation normale — ou presque.", color: "#0F6A71", bg: "#D6EAE6", border: "#0F6A71", barColor: "#0F6A71", msg: "Quelle organisation est parfaite ? Il peut arriver — comme partout — de devoir gérer une situation ubuesque, un collègue complètement timbré ou un supérieur fêlé de la cafetière. Pour autant votre organisation n'est pas une maison de fous. Comparé à ce qui se passe ailleurs, votre employeur est un modèle de normalité !"},
    {min: 161, max: 200, emoji: "😊", label: "Félicitations ! Un environnement serein et motivant.", color: "#0a4a50", bg: "#D6EAE6", border: "#0F6A71", barColor: "#0F6A71", msg: "On dirait bien que vous travaillez pour une organisation qui fait ce qu'elle dit et dit ce qu'elle fait, qui voit plus loin que le bout de son nez, où l'administratif n'est pas une fin en soi et où la hiérarchie vous considère comme une personne, pas seulement comme une machine à travailler. Restez ! Jusqu'à ce que vous ayez envie de bouger…"},
];

function computeScore(answers) {
    let n = 0, raw = 0;
    for (let i = 0; i < 40; i++) {
        if (answers[i] !== null) { n++; raw += answers[i]; }
    }
    if (n === 0) return null;
    let score;
    if (n === 40) {
        score = raw;
    } else {
        score = Math.round((raw / (n * 5)) * 200);
        score = Math.max(40, Math.min(200, score));
    }
    const result = RESULTS.find(r => score >= r.min && score <= r.max) || RESULTS[0];
    return {score, n, result};
}

export default function QvtPage({onBack}) {
    const [phase, setPhase] = useState("home");
    const [answers, setAnswers] = useState(new Array(40).fill(null));
    const [cur, setCur] = useState(0);
    const [scoreData, setScoreData] = useState(null);

    const answeredCount = answers.filter(a => a !== null).length;

    function pick(val) {
        const next = [...answers];
        next[cur] = val;
        setAnswers(next);
    }

    function go(dir) {
        const n = cur + dir;
        if (n >= 0 && n <= 39) setCur(n);
    }

    function showResult() {
        const data = computeScore(answers);
        if (!data) return;
        setScoreData(data);
        trackTestFinished("qvt");
        setPhase("result");
    }

    function restart() {
        setAnswers(new Array(40).fill(null));
        setCur(0);
        setScoreData(null);
        setPhase("home");
    }

    return (
        <div className="qvt-page">
            <header className="qvt-header">
                <div className="qvt-header-inner">
                    <div className="qvt-header-left">
                        <img
                            src="/paroles-agents-logo.png"
                            alt="SAPPM — Syndicat Autonome des Personnels des Services du Premier Ministre"
                            className="qvt-header-logo"
                        />
                        <div className="qvt-brand">
                            <span className="qvt-brand-title">Paroles d'Agents</span>
                            <span className="qvt-brand-tagline">Pour que chacun s'exprime&nbsp;!</span>
                        </div>
                    </div>
                    <div className="qvt-header-center">
                        <span className="qvt-header-headline">R&eacute;seau d'&eacute;change, de propositions et d'alertes</span>
                        <span className="qvt-header-subtext">Ensemble, faisons entendre la voix des agents 💚</span>
                    </div>
                    <div className="qvt-header-right">
                        {onBack && <button className="qvt-btn-back" onClick={onBack}>← Retour à la page d'accueil</button>}
                    </div>
                </div>
            </header>

            {onBack && (
                <div className="qvt-top-nav">
                    <button className="qvt-btn-nav" onClick={onBack}>← Retour à la page d'accueil</button>
                </div>
            )}

            <div className="qvt-card">
                {/* HOME */}
                {phase === "home" && (
                    <div className="qvt-home">
                        <span className="qvt-eyebrow">Test QVT</span>
                        <h1 className="qvt-title">Est-ce que vous travaillez dans une<br/><em>maison de fous</em>&nbsp;?</h1>
                        <p className="qvt-subtitle">
                            Grand test de d&eacute;pistage de <strong>Martin Wehle</strong>.<br/>
                            40 questions &middot; environ 5 minutes<br/>
                            Notez de <strong>1</strong> (totalement faux) &agrave; <strong>5</strong> (tout &agrave; fait juste).
                        </p>
                        <div className="qvt-legend-strip">
                            <div className="qvt-legend-pill"><span className="qvt-legend-dot" style={{background: "#2e7d32"}}/> Sain</div>
                            <div className="qvt-legend-pill"><span className="qvt-legend-dot" style={{background: "#FFC000"}}/> Normal</div>
                            <div className="qvt-legend-pill"><span className="qvt-legend-dot" style={{background: "#D4845A"}}/> Attention</div>
                            <div className="qvt-legend-pill"><span className="qvt-legend-dot" style={{background: "#b71c1c"}}/> Fuyez !</div>
                        </div>
                        <button className="qvt-btn-start" onClick={() => { trackTestStarted("qvt"); setPhase("quiz"); }}>
                            Faites le test — cliquez ICI
                        </button>
                    </div>
                )}

                {/* QUIZ */}
                {phase === "quiz" && (
                    <div>
                        <div className="qvt-prog-wrap">
                            <div className="qvt-progress-bar">
                                <div className="qvt-progress-fill" style={{width: `${Math.round(answeredCount / 40 * 100)}%`}}/>
                            </div>
                            <div className="qvt-prog-label">
                                Question {cur + 1} / 40 — {answeredCount} r&eacute;ponse{answeredCount > 1 ? "s" : ""} enregistr&eacute;e{answeredCount > 1 ? "s" : ""}
                            </div>
                        </div>

                        <div className="qvt-q-card">
                            <div className="qvt-q-num">QUESTION {cur + 1} SUR 40</div>
                            <div className="qvt-q-text">{QUESTIONS[cur]}</div>
                            <div className="qvt-scale-legend">
                                <span>Totalement faux</span>
                                <span>Tout &agrave; fait juste</span>
                            </div>
                            <div className="qvt-scale-row">
                                {[1, 2, 3, 4, 5].map(v => (
                                    <button
                                        key={v}
                                        className={`qvt-s-btn${answers[cur] === v ? " sel" : ""}`}
                                        onClick={() => pick(v)}
                                    >{v}</button>
                                ))}
                            </div>
                            <div className="qvt-scale-sub">
                                <span>1 pt — totalement faux</span>
                                <span>3 pts — moyennement juste</span>
                                <span>5 pts — tout &agrave; fait juste</span>
                            </div>
                        </div>

                        <div className="qvt-nav-row">
                            <button className="qvt-btn-nav" onClick={() => go(-1)} disabled={cur === 0}>&#8592; Pr&eacute;c&eacute;dent</button>
                            <button className="qvt-btn-voir" onClick={showResult} disabled={answeredCount === 0}>Voir mon r&eacute;sultat</button>
                            <button className="qvt-btn-nav" onClick={() => go(1)} disabled={cur === 39}>Suivant &#8594;</button>
                        </div>
                    </div>
                )}

                {/* RESULT */}
                {phase === "result" && scoreData && (
                    <div className="qvt-result">
                        <div className="qvt-r-emoji">{scoreData.result.emoji}</div>
                        <div className="qvt-r-bar-wrap">
                            <div className="qvt-r-bar-fill" style={{
                                background: scoreData.result.barColor,
                                width: `${Math.round(((scoreData.score - 40) / 160) * 100)}%`,
                            }}/>
                        </div>
                        <div className="qvt-r-score">
                            {scoreData.n < 40
                                ? `Score estimé : ${scoreData.score} / 200 (${scoreData.n} réponses sur 40)`
                                : `Score : ${scoreData.score} / 200`
                            }
                        </div>
                        <div className="qvt-r-label" style={{color: scoreData.result.color}}>{scoreData.result.label}</div>
                        {scoreData.n < 40 && (
                            <div className="qvt-r-note">{scoreData.n} questions r&eacute;pondues sur 40 — score extrapol&eacute; proportionnellement.</div>
                        )}
                        <div className="qvt-r-card" style={{background: scoreData.result.bg, borderColor: scoreData.result.border}}>
                            <p className="qvt-r-msg">{scoreData.result.msg}</p>
                        </div>
                        <button className="qvt-btn-retry" onClick={restart}>&#8634; Recommencer le test</button>
                        {onBack && (
                            <div style={{marginTop: 16}}>
                                <button className="qvt-btn-nav" onClick={onBack}>← Retour à la page d'accueil</button>
                            </div>
                        )}
                    </div>
                )}
            </div>

            <footer className="qvt-footer">
                Test de <strong>Martin Wehle</strong> — adapt&eacute; par <strong>SAPPM &middot; Paroles d'Agents</strong> &nbsp;|&nbsp; SPM / DILA
            </footer>
        </div>
    );
}
